/* eslint-disable react/require-default-props */
import React from 'react';

import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import { BiddingSummaryEditalDownload } from 'store/modules/bidding_summary_store/types';

interface BiddingSummaryEditalDownloadProps {
  editalDownload?: BiddingSummaryEditalDownload;
}

const BiddingSummaryEditalDownloadButton: React.FC<BiddingSummaryEditalDownloadProps> = ({
  editalDownload,
}) => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const files = editalDownload?.biddingFiles || [];

  if (files.length === 0) return null;

  const handleDownload = () => {
    createTrack('Resumo do Edital - Clicou em baixar edital', {
      total_arquivos: files.length,
    });
    // tracking próprio (catálogo): edital.baixou
    track('edital.baixou_edital', { total_arquivos: files.length });

    files.forEach((file) => {
      window.open(`${REACT_APP_API_ENDPOINT}${file.url}`, '_blank', 'noopener,noreferrer');
    });
  };

  return (
    <button
      type="button"
      className="btn btn-link p-0 d-inline-flex align-items-center text-primary font-weight-medium"
      onClick={handleDownload}
    >
      Baixar Edital Completo
    </button>
  );
};

export default BiddingSummaryEditalDownloadButton;
